import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { InitializerService } from '../../../shared/services/initializer-service';

import { FilteredAuditErrorItem, PagingData } from '../../../../service/proxy';
import { AuditErrorComponent } from './values/audit-error.component';
import { AuditRequestComponent } from './values/audit-request.component';
import { AuditResponseComponent } from './values/audit-response.component';
import { Router } from '@angular/router';

@Component({
    templateUrl: './audit-log-result.component.html',
    styleUrls: ['./audit-log-result.component.scss'],

    imports: [
        CommonModule,
        FormsModule,
        AuditErrorComponent,
        AuditRequestComponent,
        AuditResponseComponent
    ],

    providers: [

    ]
})
export class AuditLogResultComponent implements OnInit {
    public search: string = '';
    public paging: PagingData = new PagingData();
    public auditErrors: FilteredAuditErrorItem[] = [];
    public requestId: string = '';
    public auditError: any = {};

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private initializerService: InitializerService)
        {
            this.paging = this.initializerService.createPagingData();
        }

    ngOnInit(): void {
        this.requestId = this.route.snapshot.paramMap.get('id') || '';
    }

    onBack(): void {
        this.router.navigate([`/audit-log`]);
    }
}